module.exports = __webpack_public_path__ + "img/Drinks.99839281.jpg";